/* eslint-disable func-names */
/* eslint-disable default-param-last */
import { SET_ADDRESS } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case SET_ADDRESS:
      return action.payload;
    default:
      return state;
  }
}
